import { playShellOptions } from "@/features/play/records";
import { ProductRouteError } from "@/session/product-route-frame";
import { createFileRoute } from "@tanstack/react-router";
import { PlayPage, PlayPending } from "@/features/play";

export const Route = createFileRoute("/_site/unlisted/$coworld/$league/play")({
  loader: ({ context, location }) => {
    void context.queryClient.prefetchQuery(playShellOptions(location.href));
  },
  pendingComponent: PlayPending,
  errorComponent: ProductRouteError,
  head: () => ({
    meta: [
      { title: "Play · Softmax" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: PlayPage,
});
